const o = "_checkbox_u2zdy_1", t = "_root_u2zdy_41", e = "_texts_u2zdy_41", c = "_labelsContainer_u2zdy_60", _ = {
  checkbox: o,
  "brand-checkbox": "_brand-checkbox_u2zdy_31",
  root: t,
  texts: e,
  labelsContainer: c
};
export {
  o as checkbox,
  _ as default,
  c as labelsContainer,
  t as root,
  e as texts
};
//# sourceMappingURL=index.es650.js.map
